import React from 'react'
import { useTranslation } from 'react-i18next'

export const PicturesModalTip: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div>
      <p>
        <span className={'font-body-medium-bold'}>{t('wizard.screen.multimedia.webview.modal.tip.strong')}</span>
        {t('wizard.screen.multimedia.webview.modal.tip.text')}
      </p>
    </div>
  )
}
